import React from "react";

const cvItem = (props) => {
  // console.log(props.children);
  let descriptionChildren = [];
  let detailChildren = [];

  // if (!Array.isArray) {
  //   Array.isArray = function(arg) {
  //     return Object.prototype.toString.call(arg) === '[object Array]';
  //   };
  // }

  if (Array.isArray(props.children)) {
    props.children.forEach((child) => {

        switch (child.props.cvItemType) {
          case "Description":
            descriptionChildren.push(child);
            break;

          case "Detail":
            detailChildren.push(child);
            break;

          default:
            descriptionChildren.push(child);
            break;
        }
    });
  } else {
    descriptionChildren = props.children;
  }
  // console.log("[items: desc]: ",descriptionChildren);
  // console.log("[items: details]: ",detailChildren);

  let dateLine1 = null;
  let dateLine2 = null;
  if (!props.title) {
    /* if title is entered, date will be skipped */
    if (props.date) {
      dateLine1 = props.date;
    } else {
      if (props.date2) {
        dateLine1 = props.date1 + " - ";
        dateLine2 = props.date2;
      } else {
        dateLine1 = "Since " + props.date1;
      }
    }
  }

  let image = null;
  if (props.imgSrc) {
    image = (
      <div className="cv-item__img">
        <img src={`/assets/img/${props.imgSrc}`} alt="" />
      </div>
    );
  }

  return (
    <li className="cv__item" id={props.id ? props.id : null}>
      <div className="cv-item__head">
        <div className="cv-item__title bolder">
          <div className="Prefix-sign"> -&ensp; </div>
          <div className="bolder">
          {props.title}
          {dateLine1}
          &ensp;{dateLine2}
          </div>
        </div>
      </div>
      <div className="cv-item__body">
        <div className="cv-item__desc">{descriptionChildren}</div>
        <div className="cv-item__details">{detailChildren}</div>
      </div>
      {image}
    </li>
  );
};

export default cvItem;
